import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import SplitOne from "../elements/split/SplitOne";
import ServiceOne from "../elements/service/ServiceOne";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import PricingFive from "../elements/pricing/PricingFive";


const WebDesign = () => {
    return (
        <>
            <SEO title="Web Design"/>
            <Layout>
                {/* Start Slider Area  */}
                <SplitOne/>
                {/* End Slider Area  */}

                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = "Why Choose Us for Web Design"
                                    description = "A website is more than just a portal of information, it’s the
                                    front line for your first impressions. We take pleasure in our ability to grasp
                                    the needs of the internet market and provide customers' solutions in the most
                                    understandable way for the target market."
                                />
                            </div>
                        </div>
                        <ServiceOne
                            serviceStyle = "service__style--1 bg-color-blackest radius mt--25 rbt-border"
                            textAlign = "text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                {/* Start Elements Area  */}
                <div className="rwt-pricing-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40 mb_sm--0">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = "Our Pricing"
                                    description = "The rates for our Web Design Services are listed below."
                                />
                            </div>
                        </div>
                        <PricingFive />
                    </div>
                </div>
                {/* End Elements Area  */}
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default WebDesign;
